module.exports = __webpack_public_path__ + "static/media/bookr-logotype.6ec16573.svg";